import { getConfig } from '@b2ag/micro-front-tools'

export function getProductDefaultImage(withCloudinaryUri = true): string | undefined {
  if (!withCloudinaryUri) {
    return getConfig('PRODUCT_DEFAULT_IMAGE_ID')
  }

  return getConfig('PRODUCT_DEFAULT_IMAGE_URI')
}
